import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../../api/client';

export interface PaymentTermDto {
  paymentTermId: string;
  nameAr: string;
  nameEn: string | null;
  netDays: number;
  description: string | null;
  isActive: boolean;
}

export interface PaymentTermInput {
  nameAr: string;
  nameEn?: string | null;
  netDays: number;
  description?: string | null;
  isActive?: boolean;
}

const QK = ['payment-terms'] as const;

export function usePaymentTerms() {
  return useQuery({
    queryKey: QK,
    queryFn: async () => (await apiClient.get<PaymentTermDto[]>('/api/accounting/payment-terms')).data,
  });
}

export function useCreatePaymentTerm() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (req: PaymentTermInput) =>
      (await apiClient.post<PaymentTermDto>('/api/accounting/payment-terms', req)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}

export function useUpdatePaymentTerm() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, req }: { id: string; req: PaymentTermInput }) =>
      (await apiClient.put<PaymentTermDto>(`/api/accounting/payment-terms/${id}`, req)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}

export function useDeletePaymentTerm() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await apiClient.delete(`/api/accounting/payment-terms/${id}`);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}
